import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { ValidatorPasswordService } from "../../../components/password-validator/validator-password.service";
import { GlobalService } from '../../../global.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-reset-key',
  templateUrl: './reset-key.component.html',
  styleUrls: ['./reset-key.component.sass']
})
export class ResetKeyComponent implements OnInit {
  public validatePassword:boolean=true;
  @Input() currentPassword;
  public password:string;
  public passwordConf:string;
  @Input() forgotPasawordStatus;
  @Input() token;
  @Input() encryption;
  constructor(private global:GlobalService,  private loadingScreenService :LoadingScreenService ,private services: Service,private router:Router,private validatorPasswordService:ValidatorPasswordService) { }

  ngOnInit() {
  }
  onKey(event: any){
    this.validatorPasswordService.onKey(event.target.value);
  }
  continue(){
    if(this.encryption==true){
      this.currentPassword=btoa(this.currentPassword);
      this.token=sessionStorage.getItem("token");
    }
    if(this.validateQuestion()===true){
      this.loadingScreenService.startLoading();
      this.services.setPasswordUpdate(this.token,this.currentPassword, btoa(this.password)).subscribe(data =>{
        this.loadingScreenService.stopLoading();
        if(data.hasError ==false){
          this.global.notif(data.response);
          this.router.navigate(['/']);
        }
        else{
          this.global.notif(data.errorDisplay);
        }
      });
    }
    else{
      return
    }
  }
  validateQuestion() {
            
    if (this.currentPassword === ''|| this.currentPassword === undefined) {
        this.global.notif("Debe colocar la contraseña actual.");
        return false;
    }
    if (this.password === '' || this.password === undefined) {
        this.global.notif("Escriba su nueva contraseña");
        return false;
    }
    if (!this.password.match(/[a-z]/)) {
      this.global.notif("Debe tener al menos una letra en minúscula");
      return false;
    }
    if (!this.password.match(/[A-Z]/)) {
      this.global.notif("Debe tener al menos una letra en mayúscula");
      return false;
    }
    if (this.password.match(/\d/) || this.password.match(/\W/) || this.password.match(/[0-9]/)) {   
    } 
    else {
      this.global.notif("Debe tener al menos un número o un carácter especial");
      return false;
    }
    if (this.password.length<8) {
      this.global.notif("Debe tener al menos 8 caracteres");
      return false;
    }
    if (this.passwordConf === '' || this.passwordConf === undefined) {
        this.global.notif("Debe confirmar la contraseña");
        return false;
    }
    if (this.password !== this.passwordConf) {
        this.global.notif("La contraseña actual no coincide con la confirmación.");
        return false;
    }
    return true;
  }
}